<template>
  <div id="HomePage" class="Page Home" v-if="data">
    <section id="Top" class="Section Section_blue">
      <div class="Section_background"></div>

      <div class="Section_wrapper">
        <div class="Col">
          <transition name="bottom" appear>
            <h2 v-html="data.top_title"></h2>
          </transition>
          <transition name="bottom" appear>
            <div class="Content" v-html="data.top_content"></div>
          </transition>
        </div>

        <div class="Col">
          <transition name="scale" appear>
            <div class="Diamond">
              <transition name="scale" appear>
                <button class="Diamond_more" @click="openTooltip">?</button>
              </transition>

              <div class="Diamond_shape"></div>

              <div class="Diamond_wrapper">

                <div class="Diamond_number">

                  <animated-number
                    class="Diamond_number_value"
                    :value="6.8"
                    :easing="'easeOutQuad'"
                    :duration="800"
                    :delay="600"
                    :formatValue="theFormat"
                  />

                  <span class="Diamond_number_count">/ 10</span>
                </div>
                <p>Le Qualiscore 2019<br>en France</p>

              </div>
            </div>
          </transition>

        </div>
      </div>
    </section>

    <section class="Inset">
      <div class="Inset_background"></div>
      <div class="Inset_wrapper">
        <transition name="bottom" appear>
          <h3 v-html="data.top_inset_title"></h3>
        </transition>
        <transition name="bottom" appear>
          <router-link :to="{ name: 'qualiscore' }"><button class="Cta Cta_red" @click="$gtm.trackEvent({ category: 'button_home_cta', action: 'click', label: !user.surveys || user.surveys.qualiscore.completed == false ? 'home_cta_calculer' : 'home_cta_mon_evaluation' })">{{ !user.surveys || user.surveys.qualiscore.completed == false ? "Calculez votre Qualiscore" : "Mon évaluation" }}</button></router-link>
        </transition>
        <transition name="bottom" appear>
          <div v-html="data.top_inset_content"></div>
        </transition>
      </div>
      <img class="Inset_house" src="../../public/static/images/illustrations/i_househeader.svg" />
    </section>

    <section id="Video" class="Section">
      <div class="Section_wrapper">
        <h6 v-html="data.video_subtitle"></h6>
        <h3 v-html="data.video_title"></h3>

        <div class="Video_illustration" @click="openVideo">
          <MouseParallax :mouseRatio="50"><img class="Video_illustration_background" src="../../public/static/images/video_background.jpg" /></MouseParallax>
          <MouseParallax :mouseRatio="85"><img class="Video_illustration_house" src="../../public/static/images/video_background_house.png" /></MouseParallax>
          <img class="Video_illustration_play" src="../../public/static/images/play.svg" />
        </div>

        <router-link :to="{ name: 'page', params: { slug: 'analyse' } }"><button class="Cta Cta_red">Consulter l’analyse complète de nos experts</button></router-link>
      </div>
    </section>

    <section id="Explore" class="Section Section_blue">

      <img class="Shape" src="../../public/static/images/shape.svg" ref="exploreshape"/>
      <img class="City" src="../../public/static/images/city_background.jpg" ref="explorecity"/>

      <div class="Slash Slash_grey"></div>

      <div class="Section_wrapper">

        <div class="Col_content">
          <h3 v-html="data.explore_title"></h3>
          <div class="Content" v-html="data.explore_content"></div>

          <router-link :to="{ name: 'survey', params: { slug:  'qualiscore' } }"><button class="Cta Cta_white Cta_line">Voir les résultats</button></router-link>
        </div>

        <div class="Col_slider">
          <NumberKeySlider :data="data.chiffres_cles" />
        </div>
      </div>
    </section>

    <section id="Editions" class="Section Section_grey">

      <img class="Shape" src="../../public/static/images/shape-cyan.svg" ref="editionsshape"/>

      <div class="Section_wrapper">
        <h3 v-html="data.editions_title"></h3>

        <EditionsSwiper :data="data.editions" />
      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapActions, mapState } from 'vuex'
  import page from '@/mixins/page'

  import MouseParallax from "@/components/MouseParallax"
  import NumberKeySlider from "@/components/NumberKeySlider"
  import EditionsSwiper from "@/components/EditionsSwiper"
  import Footer from "@/components/partials/Footer"
  import AnimatedNumber from "animated-number-vue";

  export default {
    name: "Home",
    mixins: [ 'page' ],
    components: { MouseParallax, NumberKeySlider, EditionsSwiper, Footer, AnimatedNumber },
    metaInfo: {
      title: "Baromètre Qualitel 2019 : vous aussi, évaluez la qualité perçue de votre logement !",
      meta: [
        {
          property: 'og:title',
          content: "Baromètre Qualitel 2019 : vous aussi, évaluez la qualité perçue de votre logement !"
        },
        {
          property: 'og:description',
          content: "Consultez les résultats du Baromètre Qualitel 2019, évaluez votre logement et obtenez des conseils pour améliorer la qualité de votre logement."
        },
        {
          property: 'og:image',
          content: 'https://www.qualitel.org/jevalue-mon-logement/static/images/social/social-2.jpg'
        },
        {
          property: 'twitter:title',
          content: "Baromètre Qualitel 2019 : vous aussi, évaluez la qualité perçue de votre logement !"
        },
        {
          property: 'twitter:description',
          content: "Consultez les résultats du Baromètre Qualitel 2019, évaluez votre logement et obtenez des conseils pour améliorer la qualité de votre logement."
        },
        {
          property: 'twitter:image',
          content: 'https://www.qualitel.org/jevalue-mon-logement/static/images/social/social-2.jpg'
        }
      ]
    },
    data() {
      return {
        data: null
      }
    },
    computed: {
      ...mapState([
        'user'
      ])
    },
    beforeRouteEnter (to, from, next) {
      Vue.$api.getPage('home')
      .then(response => {
        console.log(response)
        next(vm => vm.setData(response.data))
      })
    },
    methods: {
      openTooltip()
      {
        this.$emit('openPanel', { type: 'qualiscore' })
        this.$gtm.trackEvent({ category: 'button_home_tooltip', action: 'click', label: 'home_tooltip' })
      },
      openVideo()
      {
        this.$emit('openPanel', { type: 'video', data: this.data.video_embed })
        this.$gtm.trackEvent({ category: 'button_home_player', action: 'click', label: 'home_player' })
      },
      theFormat(number) {
        return number.toFixed(1).replace(".", ",");
      },
      setData(data)
      {
        this.data = data

        document.body.scrollTop = 0
      }
    },
    mounted()
    {
      setTimeout( () => {
        this.$scroll.set(document.body.querySelector('.Video_illustration_background'), { y: 50 }, { y: 0 }, { y: 100 }, null, -0.4)
        this.$scroll.set(document.body.querySelector('#Top .Section_background'), { y: 0 }, { y: 0 }, { y: 60 }, null, this.$tools.isMobile() ? -1 : 0 )
        this.$scroll.set(this.$refs.exploreshape, { y: -70 }, { y: 0 }, { y: -140 }, null, -0.6)
        this.$scroll.set(this.$refs.explorecity, { y: 0 }, { y: 0 }, { y: 60 })
        this.$scroll.set(this.$refs.editionsshape, { y: 70 }, { y: 0 }, { y: 140 }, null, -0.6)
        this.$scroll.set(document.body.querySelector('.NumberKeySlider_before'), { y: 20 }, { y: 0 }, { y: 40 })
      }, 10)
    }
  }
</script>

<style lang="stylus">
#HomePage

  .Section_wrapper

    padding-top 100px
    padding-bottom 100px

    @media $small

      padding-top 40px
      padding-bottom 40px

  #Editions

    .Section_wrapper

      padding-left 0px
      padding-right 0px

    .Shape

      height 364px
      width 364px
      left -160px
      bottom -80px

  #Explore

    text-align left

    .Section_wrapper

      display flex
      flex-direction row
      align-items flex-start
      justify-content space-between
      flex-wrap wrap
      max-width: calc(990px + 25px + 25px);
      width: 100%;
      margin auto auto
      box-sizing initial
      padding-bottom 50px


      @media $medium

        flex-direction column
        box-sizing border-box

      @media $small

        padding-bottom 20px

      .Col_content

        max-width 490px
        width 100%

        @media $large

          max-width 360px

        @media $medium

          max-width 100%
          margin 0px 0px
          text-align center

        .Cta

          margin-top 20px

        h3, p

          color white

      .Col_slider

        margin auto
        position relative
        z-index 1

        @media $small

          width calc(100vw + 25px)
          left -25px

    .City

      width 100%
      max-width 1000px
      position absolute
      bottom 30px
      left 10%

      @media $medium

        left auto
        right 0px
        bottom 50px

      @media $small

        left -30%
        right auto
        bottom 0px

    .Slash

      z-index 1

    .Shape

      width 456px
      height 456px
      right -190px
      top -180px
      opacity 0.05

      @media $medium

        display none

  #Video

    background-color $n4

    .Section_wrapper

      padding-left 0px
      padding-right 0px

    h6, h3

      position relative
      display block
      z-index 1

    .Cta

      margin-top 10px
      position relative

      @media $medium

        margin-top 40px

      @media $small

        max-width 90vw

    .Video_illustration

      position relative
      cursor pointer

      &:hover

        .Video_illustration

          &_play

            transform translateX(-50%) scale(1.4)

          &_background

            opacity 0.6

      &_play

        width 80px
        height 80px
        position absolute
        top 30px
        left 50%
        transform translateX(-50%)
        transition 1s $ease

        @media $small

          width 60px
          height 60px
          top 0px

      &_house

        width 100%
        position relative

        @media $small

          width 180%
          left -10%

      .MouseParallax:nth-child(2)

        &:before

          content ''
          width 100%
          height 50vh
          background-color $n4
          position absolute
          top 80%
          left 0px

      &_background

        width 100%
        position absolute
        z-index -1
        top 0px
        left 0px
        transition opacity 0.6s $ease

        @media $small

          left -30%
          width 170%

  #Top

    text-align left
    display flex
    align-items center
    justify-content center
    flex-direction column
    overflow hidden
    min-height 60vh

    .MouseParallax

      position absolute
      top 0px
      left 0px
      width 100%
      height 100%

    .Section_background

      background-image url(../../public/static/images/city_background.jpg)
      background-repeat no-repeat
      background-position bottom right
      background-size contain
      position absolute
      top 0px
      left 0px
      width 105%
      height 105%

      @media $small

        background-size 110% auto
        top -5%

    .Section_wrapper

      display flex
      flex-direction row
      align-items flex-start
      justify-content space-between
      flex-wrap wrap
      max-width: calc(990px + 25px + 25px);
      width: 100%;
      box-sizing initial
      margin auto auto
      padding-bottom 200px
      padding-top 80px

      @media $medium

        flex-direction column
        box-sizing border-box

      @media $small

        margin auto auto
        padding-bottom 360px!important

    .Col:nth-child(2)

      margin auto auto

      @media $medium

        width 100%
        margin-top 90px

    .Col:nth-child(1)

      max-width 490px
      width 100%

      @media $medium

        text-align center
        max-width unset

      .Cta

        margin-top 30px

      a

        display block
        color inherit
        text-decoration none
        transition-delay 0.2s

      .Content

        transition-delay 0.1s

      h2, p

        color white

      h2

        @media $medium

          margin-left auto
          margin-right auto

      p

        font-size 18px
        line-height 24px

        @media $small

          font-size 14px
          line-height 22px
.ie

  .Video_illustration

    width 100vw

</style>
